import { formDataRequest, postRequest } from "../libs/AxiosService.util";

export async function serviceEmailBlockedUserList(params) {
  return await postRequest("email/composer/blocked/email/list", params);
}
export async function serviceEmailUnBlockUser(params) {
  return await postRequest("email/composer/unblock/emails", params);
}